import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import RoutesConstants from '../../../@commons/constants/routes.constants';

/**
 * Bottom-sheet « Que souhaitez-vous faire ? » (maquette 02).
 * Déclenché par le « + » de Mon Potager.
 */
@Component({
  selector: 'vw-garden-actions-toast',
  imports: [SharedModule, CommonModule, TranslateModule],
  templateUrl: './garden-actions-toast.component.html',
  styleUrl: './garden-actions-toast.component.scss',
})
export class GardenActionsToastComponent extends BaseToastComponent {
  constructor(private router: Router) {
    super();
  }

  addBed(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.GARDEN_BED_CREATE]);
  }

  addPlant(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.GARDEN_ADDPLANT]);
  }
}
